import { type TreeItemsStateType, type TreeViewItemType } from '#components/treeView';
import type { FilterFromSearch } from '#domain/core/filter/filter.mapper';
import { type DefaultFiltersItemType } from '@carrefour-gcs/shared';

export const convertFiltersToDto = (items: DefaultFiltersItemType[] | undefined) => {
  if (items) {
    return items.map(({ nodeId }) => nodeId);
  }

  return [];
};

export function getCheckedItems(filterTree: TreeItemsStateType) {
  return Object.fromEntries(Object.entries(filterTree).filter(([, state]) => state.state === 'checked'));
}

export function findCheckedChildren(node: TreeViewItemType): TreeViewItemType[] {
  if (node.checkedStatus === 'checked') {
    return [node];
  } else if (node?.children?.length > 0) {
    const checkedChildren: TreeViewItemType[] = [];
    for (const child of node.children) {
      checkedChildren.push(...findCheckedChildren(child));
    }
    return checkedChildren;
  } else {
    return [];
  }
}

export function transformFilterFromSearch<T extends FilterFromSearch>(data: T, pattern: string, level = 0): T {
  return {
    ...data,
    label: pattern.replace(/{level}/g, level.toString()),
    children: (data.children?.map((child, index) =>
      transformFilterFromSearch(child, pattern, level * 10 + (index + 1))
    ) ?? []) as T['children']
  };
}
